import Api from './Api'

export default {
  async get(parameters) {
    const api = await Api()
    return api.post('agent', parameters)
  },
  async getAll(parameters) {
    const api = await Api()
    const agents = api.post('agents', parameters)
    return agents
  },
  async delete(parameters) {
    const api = await Api()
    return api.post('agent/delete', parameters)
  },
  async update(parameters) {
    const api = await Api()
    return api.post('agent/update', parameters)
  },
  async create(parameters) {
    const api = await Api()
    return api.post('agent/create', parameters)
  },
  async download(agentId) {
    // const api = await Api();
    // return api.get(`agent/download/${agentId}`);
    window.open(
      `${process.env.VUE_APP_SERVER_SSL_FLAG ? 'https' : 'http'}://${
        process.env.VUE_APP_SERVER_HOST_NAME
      }:${process.env.VUE_APP_SERVER_PORT}/agent/download/${agentId}`,
      '_blank'
    )
  },
}
